import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import * as MessageActions from '../../common/messageBox/actions/actions';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchJDEParameters = () => apiActionCreator({
  'endpoint': '/udc/cars',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_JDE_PARAMETERS,
    ActionTypes.FETCHED_JDE_PARAMETERS,
    [
      ActionTypes.FETCHED_JDE_PARAMETERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchClassesWithSubclasses = () => apiActionCreator({
  'endpoint': '/master-vehicles/segment-subsegment-catalog',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_CLASSES,
    ActionTypes.FETCHED_CLASSES,
    [
      ActionTypes.FETCHED_CLASSES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchMasterVEHSData = (parameters = {}) => {
  const allFilters = getUrlParameters(parameters);
  console.log('parameters', parameters);
  return apiActionCreator({
    'endpoint': `/master-vehicles${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_MASTER_VEHICLES_LIST,
      ActionTypes.FETCHED_MASTER_VEHICLES_LIST,
      [
        ActionTypes.FETCHED_MASTER_VEHICLES_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};
export const getMasterVehicleImages = (master) =>
  apiActionCreator({
    'endpoint': `/master-vehicles/charge-file/${master}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_MASTER_VEHICLE_ATTACHMENTS,
      ActionTypes.FETCHED_MASTER_VEHICLE_ATTACHMENTS,
      [ActionTypes.FETCHED_MASTER_VEHICLE_ATTACHMENTS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
export const fetchMasterVEH = (code) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/master-vehicles/vehicle/${code}/search`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_MASTER_VEH,
        [
          (response) => {
            dispatch(getMasterVehicleImages(code));
            return {
              'type': ActionTypes.FETCHED_MASTER_VEH,
            };
          },
        ],
        [ActionTypes.FETCHED_MASTER_VEH_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchMasterVEHColor = (code) => apiActionCreator({
  'endpoint': `/master-vehicles/vehicle-color/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_MASTER_VEH_COLOR,
    ActionTypes.FETCHED_MASTER_VEH_COLOR,
    [
      ActionTypes.FETCHED_MASTER_VEH_COLOR_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const changeRequestState = (state) => ({
  'type': ActionTypes.UPDATE_REQUEST_STATE,
  'payload': state,
});

export const updateMasterVEH = (code, action, masterData) => apiActionCreator({
  'endpoint': `/master-vehicles/vehicle/${code}/${action}`,
  'authenticated': true,
  'types': [
    ActionTypes.UPDATING_MASTER_VEH,
    [
      ActionTypes.UPDATED_MASTER_VEH,
      MessageActions.addMessageBoxInfo('Solicitud actualizada satisfactoriamente'),
    ],
    [
      ActionTypes.UPDATED_MASTER_VEH_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': masterData,
});

export const updateRejectMasterVEH = (code, masterData) => apiActionCreator({
  'endpoint': `/master-vehicles/vehicle-reject/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.UPDATING_REJECT_MASTER_VEH,
    [
      ActionTypes.UPDATED_REJECT_MASTER_VEH,
      MessageActions.addMessageBoxInfo('Solicitud rechazada satisfactoriamente'),
    ],
    [
      ActionTypes.UPDATED_REJECT_MASTER_VEH_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': masterData,
});

export const createMasterVEH = (masterVehData) => apiActionCreator({
  'endpoint': '/master-vehicles',
  'authenticated': true,
  'types': [
    ActionTypes.CREATING_MASTER_VEH,
    [
      ActionTypes.CREATED_MASTER_VEH,
      MessageActions.addMessageBoxInfo('Maestro de Vehículos Creado Satisfactoriamente'),
    ],
    [
      ActionTypes.CREATED_MASTER_VEH_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': masterVehData,
});

export const deleteMasterVEHData = () => ({
  'type': ActionTypes.DELETE_MASTERVEH_DATA,
});

export const fetchVehicleMasterAudit = (code) => apiActionCreator({
  'endpoint': `/master-vehicles/vehicle/${code}/audit`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_VEHICLE_MASTER_AUDIT,
    ActionTypes.FETCHED_VEHICLE_MASTER_AUDIT,
    [
      ActionTypes.FETCHED_VEHICLE_MASTER_AUDIT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
export const saveVehicleFile = (master, code, data) => apiActionCreator({
  'endpoint': `/master-vehicles/charge-file/${master}`,
  'authenticated': true,
  'types':
  [
    ActionTypes.SAVE_VEHICLE_FILE_REQUEST,
    [
      ActionTypes.SAVE_VEHICLE_FILE_SUCCESS,
      MessageActions.addMessageBoxInfo('Archivos cargados con éxito'),
    ],
    [
      ActionTypes.SAVE_VEHICLE_FILE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'data': data,
});
export const setImageAttachments = (files) => ({
  'type': ActionTypes.SET_IMAGE_FILES,
  'payload': files,
});
export const saveVehicleFileAudi = (data) => apiActionCreator({
  'endpoint': '/master-vehicles/vehicle-file-audi',
  'authenticated': true,
  'types':
  [
    ActionTypes.SAVE_VEHICLE_FILE_AUDI_REQUEST,
    [
      ActionTypes.SAVE_VEHICLE_FILE_AUDI_SUCCESS,
    ],
    [
      ActionTypes.SAVE_VEHICLE_FILE_AUDI_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});
